import { securePaymentApi } from "@/service/axios";

const path = "secure-update-lead";
class SecurePaymentService {
    async register(payload) {
        try {
            const data = await securePaymentApi.post(`${path}/register`, payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async isValidLink(link) {
        try {
            const data = await securePaymentApi.get(`${path}/is-valid-link/${link}`);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getLinkData(link) {
        try {
            const data = await securePaymentApi.get(`${path}/get-link-data/${link}`);
            return data;
        } catch (error) {
            throw error;
        }
    }
    async getStates(){
      try {
        const {data} = await securePaymentApi.get(`${path}/states`);
        return data;
    } catch (error) {
        throw error;
    }
    }
}
export default new SecurePaymentService();
